import * as Lockr from 'lockr';
import {
	SET_DEPLOY_TYPE__ACTIONTYPE,
	SET_RATER_TYPE__ACTIONTYPE,
	SET_DEPLOY_ERROR_MESSAGE__ACTIONTYPE,
	DEPLOY_CONFIG__ACTIONTYPES,
} from '../../constants/config-tester';
import {GenericHttpError, isConfigTesterValidationError} from '../../../errors';

const ASSETS_KEY = 'config_tester_assets';
const INITIAL_STATE: ConfigTester.AssetState = {
	deployType: 'TEST',
	raterType: 'SOCOTRA_RATER',
	deployResponse: null,
	lastTenantNameSuffix: '',
	errorMessage: null,
};

function getInitialState(): ConfigTester.AssetState {
	return Lockr.get<ConfigTester.AssetState>(ASSETS_KEY, INITIAL_STATE);
}

function saveAssetState(state: ConfigTester.AssetState): ConfigTester.AssetState {
	Lockr.set(ASSETS_KEY, state);
	return state;
}

function handleAssetsAsyncSuccess(
	state: ConfigTester.AssetState,
	data: ConfigTester.DeployResult): ConfigTester.AssetState {
	return saveAssetState({
		...state,
		errorMessage: null,
		deployType: 'LAST',
		lastTenantNameSuffix: data.lastTenantNameSuffix,
		deployResponse: data.deployResponse,
	});
}

function getDeployErrorType(error: GenericHttpError, deployType: ConfigTester.DeployType) {
	if (isConfigTesterValidationError(error, deployType)) {
		return 'VALIDATION_ERROR';
	} else if (error.result && !error.result.message) {
		return 'HAS_LOG_FILE';
	} else if (error.result) {
		return 'HAS_NO_LOG_FILE';
	} else {
		return 'UNKNOWN';
	}
}

function handleAssetsAsyncFailure(
		state: ConfigTester.AssetState,
		error: any): ConfigTester.AssetState {
	switch (getDeployErrorType(error, state.deployType)) {
		case 'VALIDATION_ERROR':
			return saveAssetState({
				...state,
				deployResponse: null,
				errorMessage: error.message,
			});
		case 'HAS_LOG_FILE':
			return saveAssetState({
				...state,
				deployResponse: error.result,
				errorMessage: error.statusText,
			});
		case 'HAS_NO_LOG_FILE':
			return saveAssetState({
				...state,
				deployResponse: null,
				errorMessage: `Failed to deploy configuration: ${error.result.message}`,
			});
		default:
			return saveAssetState({
				...state,
				deployResponse: null,
				errorMessage: `An unexpected error occured during deployment: ${error.message}`,
			});
	}
}

export default function assets(
		state: ConfigTester.AssetState = getInitialState(),
		action: Action): ConfigTester.AssetState {
	const nextState: ConfigTester.AssetState = Object.assign({}, state);
	if (action.type === 'ASYNC_SUCCESS' && action.successReference === DEPLOY_CONFIG__ACTIONTYPES.SUCCESS) {
		const {asyncSuccessData: {data}} = action;
		return handleAssetsAsyncSuccess(nextState, data);
	} else if (action.type === 'ASYNC_FAILURE' && action.failureReference === DEPLOY_CONFIG__ACTIONTYPES.FAILURE) {
		const {asyncFailureData: {error}} = action;
		return handleAssetsAsyncFailure(nextState, error);
	} else if (action.type === SET_DEPLOY_TYPE__ACTIONTYPE) {
		return saveAssetState({
			...nextState,
			deployType: action.deployType,
		});
	} else if (action.type === SET_RATER_TYPE__ACTIONTYPE) {
		return saveAssetState({
			...nextState,
			raterType: action.raterType,
		});
	} else if (action.type === SET_DEPLOY_ERROR_MESSAGE__ACTIONTYPE) {
		return saveAssetState({
			...nextState,
			errorMessage: action.errorMessage,
		});
	} else {
		return nextState;
	}
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./ts/store/reducers/config-tester/assets.ts